import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Error } from "@bw/forms"

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const Label = styled.label`
  display: block;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.025em;
  margin-bottom: 0.25em;
`

const Asterisk = styled.span`
  &:before {
    content: "*";
    margin-left: 0.3em;
    color: red;
  }
`

const FormField = ({ children, ...props }) => {
  return (
    <Wrapper>
      <Label htmlFor={props.name}>
        {props.title}
        {props.required && <Asterisk />}
      </Label>
      {props.help && props.helpPosition === "above" && (
        <small>{props.help}</small>
      )}
      {children}
      {props.help && props.helpPosition === "below" && (
        <small>{props.help}</small>
      )}
      {props.name && <Error name={props.name} />}
    </Wrapper>
  )
}

FormField.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  help: PropTypes.string,
  helpPosition: PropTypes.string,
  required: PropTypes.bool,
}

FormField.defaultProps = {
  helpPosition: "above",
  required: false,
}

export { FormField }
